import React,{useEffect} from 'react'
import SidebarInf03 from '../../components/sidebar/SidebarInf03'
import 'highlight.js/styles/atom-one-dark.css';
import hljs from 'highlight.js';




const Connclosexampp = () => {

  useEffect(() => {
    hljs.addPlugin({
        'after:highlightElement': ({ result, el }) => {
            const lines = document.createElement('div');
            if (!result.value.includes('<span class="line-num">')) {
                lines.innerHTML = result.value.replace(/^/gm, '<span class="line-num"></span>');
            }
            el.replaceChildren(...lines.childNodes);
        }
    });


    if (!document.querySelector('.hljs')) {
      hljs.highlightAll();
  }
   
  });


  return (
    <div id='rozwiazaniainf03'>

    <SidebarInf03></SidebarInf03>

        <div id="rozwiazanieustawienie">
          <div id="rozwiazanie" style={{ padding: '20px', maxWidth: '900px', margin: 'auto', textAlign: "left" }}>
            <h1>Łączenie i zamykanie połączenia z bazą danych</h1>
            <section>
              <hr></hr>
              <h2>Wprowadzenie</h2>
              <blockquote class="introduction">
                <strong>Zanim zaczniemy...</strong>
                Sprawdź czy masz zainstalowanego XAMPPa oraz utworzoną przykładową bazę danych w której są jakieś dane.
                Również w tej sekcji będzie ci potrzebny jakiś plik PHP w folderze htdocs, przez niego wejdziesz na stronę
                wpisując w wyszukiwarkę localhost/<b>nazwapliku.php albo scieżka</b>.
              </blockquote>
              <hr></hr>
              <h2>Tworzenie pliku PHP</h2>
              <p>
                Stwórz nowy plik PHP i umieść go w katalogu <code>htdocs</code> w folderze XAMPP (zwykle <code>C:\xampp\htdocs</code> na Windowsie lub <code>/Applications/XAMPP/htdocs</code> na macOS). Nazwij plik, na przykład, <code>connect.php</code>.
              </p>
              <hr></hr>
            </section>
            <section>
            <h5 className="card-title mt-4">Kod PHP do połączenia z bazą danych</h5>
              <p>
                Wewnątrz pliku <code>connect.php</code> dodaj poniższy kod, aby połączyć się z bazą danych:
              </p>
              <h4>Podejście obiektowe</h4>
              <pre>
                <code>
{`<?php
$servername = "localhost";
$username = "root";
$password = "";
$dbname = "mydatabase";

// Tworzenie połączenia
$conn = new mysqli($servername, $username, $password, $dbname);

// Sprawdzanie połączenia
if ($conn->connect_error) {
    die("Brak połączenia: " . $conn->connect_error);
}

echo "Połączono teraz możesz robić wszystko muhahhaha";

// Zamykanie połączenia
$conn->close();

?>`}
                </code>
              </pre>

              <h4>Podejście proceduralne</h4>
              <pre>
                <code>
                {`<?php
$servername = "localhost";
$username = "root";
$password = "";
$dbname = "mydatabase";

// Tworzenie połączenia
$conn = mysqli_connect($servername, $username, $password, $dbname);

// Sprawdzanie połączenia
if (!$conn) {
    die("Brak połączenia: " . mysqli_connect_error());
}

echo "Połączono teraz możesz robić wszystko muhahhaha";

// Zamykanie połączenia
mysqli_close($conn);
?>`}
                </code>
              </pre>
           
                <ul>
                  <li><code>$servername</code>: Serwer bazy danych, zazwyczaj <code>localhost</code> dla lokalnych środowisk.</li>
                  <li><code>$username</code>: Nazwa użytkownika bazy danych, zazwyczaj <code>root</code> w XAMPP.</li>
                  <li><code>$password</code>: Hasło użytkownika bazy danych, domyślnie puste w XAMPP.</li>
                  <li><code>$dbname</code>: Nazwa bazy danych, którą utworzyłeś w phpMyAdmin, na przykład <code>mydatabase</code>.</li>
                </ul>

<blockquote className="info">
    <strong>Podejście obiektowe a proceduralne</strong>
    Podejście proceduralne i obiektowe to dwa różne paradygmaty programowania. W podejściu proceduralnym programowanie polega na sekwencyjnym wykonywaniu funkcji i procedur, gdzie dane są przetwarzane krok po kroku. Przykładem jest użycie funkcji takich jak <code>mysqli_connect</code> i <code>mysqli_close</code> w PHP. Natomiast w podejściu obiektowym programowanie koncentruje się na tworzeniu obiektów, które łączą dane i metody ich przetwarzania. W PHP przykładem jest użycie klasy <code>mysqli</code> do tworzenia instancji obiektów połączenia z bazą danych. Podejście obiektowe ułatwia organizację kodu, ponowne użycie oraz jego rozszerzalność.
</blockquote>


            </section>
          </div>
          
        </div>
    </div>
  )
}

export default Connclosexampp

